@if (extension) {
  <span class="extension-badge"
        [title]="extendedUntil
          ? ('benchOverview.extension.tooltipUntil' | translate: {date: extendedUntil | date: 'dd.MM.yyyy'})
          : ('benchOverview.extension.tooltip' | translate)">
    <svg class="extension-badge__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d="M13 8a5 5 0 1 1-1.46-3.54" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M13.2 2.2v3.3H9.9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>{{ 'benchOverview.extension.badge' | translate }}</span>
} @else {
  <span class="extension-badge__none">—</span>
}
